import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RightArrow14 = (props: SvgProps) => (
  <Svg
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m6.125 10.5 3.5-3.5-3.5-3.5"
    />
  </Svg>
);
export default RightArrow14;
